import {Component, OnInit} from '@angular/core';
import {
  BASK_BRAND_NAME, BASK_URL_CHECK,
  JOINT_MAINTENANCE_APPLICATION_PATH,
  JOINT_APPLICATION_DETAILS_KEY, TCB_BRAND_NAME, PAGE_BREAK_PATH, JOINT_MAINTENANCE_PAGE_BREAK_PATH,
} from "../../../shared/constants";
import {CoreService} from "../../../shared/services/core.service";
import {FacadeService} from "../../../shared/service-facade/facade.service";
import {HttpStatusCode} from "@angular/common/http";
import {
  ApplicationDetailLog, ApplicationLogDetailsRequest,
  ApplicationLogStepRequest,
  ApplicationLogsUpdateRequest,
  Log
} from "leia-api";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute} from "@angular/router";
import {CodeVerificationService} from "../../../shared/services/code-verification.service";
import {SectionStatusService} from "../../../status-tracker/section-status.service";
import {ReviewService} from "../../../review/services/review.service";
import {EligibilityService} from "../../../shared/services/eligibility.service";
import {UtilitiesService} from "../../../shared/services/utilities.service";
import {MainLayoutService} from "../../../shared/services/main-layout.service";
import {environment} from "../../../../environments/environment";
import OnboardingSourceEnum = ApplicationLogStepRequest.OnboardingSourceEnum;
import StatusEnum = ApplicationLogsUpdateRequest.StatusEnum;
import {ThemeService} from "../../../core/services/theme.service";

@Component({
  selector: 'app-invitation-landing-page',
  templateUrl: './invitation-landing-page.component.html',
  styleUrls: ['./invitation-landing-page.component.scss']
})

export class InvitationLandingPageComponent implements OnInit {
  title = '';
  productName = '';
  expireDate = '';
  secureSessionId: string | null = "";
  invitationError = false;
  sessionId: string = "";
  disableButton = false;

  private _applicationDetailLog!: ApplicationDetailLog;
  private _brandId!: number;

  constructor(
    private coreService: CoreService,
    private facadeService: FacadeService,
    public dialog: MatDialog,
    private reviewService: ReviewService,
    private mainLayoutService: MainLayoutService,
    private themeService: ThemeService,
    private utils: UtilitiesService) {
  }

  ngOnInit(): void {
    const {
      expiryDate,
      invitedBy,
      secureSessionId
    } = JSON.parse(this.facadeService.getStorageItem(JOINT_APPLICATION_DETAILS_KEY));

    this.title = `${invitedBy} has added you to their ${location.href.includes(BASK_URL_CHECK)? BASK_BRAND_NAME : TCB_BRAND_NAME} Account(s)`;

    this.secureSessionId = secureSessionId;
    this.expireDate = expiryDate;
    this.coreService.isDataLoaded.next(true);
    this.coreService.disableBackButton();
    this.mainLayoutService.setPageTitle("Accept Your Invitation");
  }

  handleInvitation() {
    this.disableButton = true;
    this.facadeService.verifyCode({
      secureSessionId: this.secureSessionId!,
      acceptInvitation: true
    }).toPromise().then((response) => {
      if (!response.verified)
        throw HttpStatusCode.InternalServerError

      this.sessionId = response.sessionId!;

      this.facadeService.attachExistingSession(response.sessionId!)
        .then(() => {
          this.facadeService.getApplicationLog(this.sessionId).toPromise()
            .then(applicantDetailLog => {
              this._applicationDetailLog = applicantDetailLog;

              // Invitation will always initialy have one product
              const { productUID } = applicantDetailLog.products![0];
              this.facadeService.addStorageItem("productUid", productUID!);
              return this.facadeService.getProduct(productUID!);
            })
            .then(async product => {
              this.facadeService.setBrandId(product.brandId.toString());
              this.themeService.setThemeByBrandId(product.brandId);
              this._brandId = product.brandId;

              let alloyWorkflowId : string = "";
              if(product.alloyWorkflowId! > 0) alloyWorkflowId = product.alloyWorkflowId.toString();
              this.facadeService.addStorageItem("alloyWorkflowId", alloyWorkflowId);
              this.facadeService.addStorageItem("olbGroupId", product.olbGroupId.toString());

              await this.facadeService.initializeProductStateUponVerification(product, this._applicationDetailLog);

              return Promise.all([
                this.facadeService.getBrandSettings(environment.app_settings_version, product.brandId),
                this.facadeService.getBrandSettings(environment.app_settings_version, product.brandId, product.productUID)
              ])

            }).then(settings => {
            const brandSettings = settings[0], productSettings = settings[1];

            brandSettings.forEach(setting => {
              if (setting.name !== undefined && setting.value !== undefined) {
                this.facadeService.addStorageItem(setting.name, setting.value);
              }
            });

            productSettings.forEach(setting => {
              if (setting.name !== undefined && setting.value !== undefined) {
                this.facadeService.addStorageItem(setting.name, setting.value);
              }
            });

            // Notify product and brand settings loaded
            this.facadeService.brandProductSettingsLoaded$.next(true);

            // Load the theme for the site.
            this.facadeService.setBrandTheme();
          })
            .then(() => this.facadeService.getCatalogData().toPromise())
            .then(async () => {
              this.reviewService.setApplicationData(
                this._applicationDetailLog,
                this.facadeService.getAnnualIncomes(),
                this.facadeService.getAllIncomeSources(),
                this.facadeService.getAllOccupations(),
                this.facadeService.getCountries(),
                this._brandId,
                true,
                false
              )
            })
            .then(() => {
              this.coreService.navigate(`/${JOINT_MAINTENANCE_APPLICATION_PATH}`);
            })
        }).catch(() => {
        this.invitationError = true;
      });
    });
  }

  navigateTo(url: string): void {
    window.location.href = url;
  }
}
